export const standardEasing = 'cubic-bezier(0.4, 0, 0.2, 1)'
export const deceleratedEasing = 'cubic-bezier(0.0, 0, 0.2, 1)' // Entering
export const acceleratedEasing = 'cubic-bezier(0.4, 0, 1, 1)' // Leaving
